module.exports = __webpack_public_path__ + "static/media/female-icon.78318778.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/female-icon.png
// module id = 502
// module chunks = 0